"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupingTree = void 0;
class GroupingTree {
    keyFn;
    root = null;
    constructor(keyFn) {
        this.keyFn = keyFn;
    }
    insert(item) {
        if (this.root === null) {
            this.root = new Node(this.keyFn(item), [item]);
            return;
        }
        this._insert(this.root, item);
    }
    insertAll(items) {
        items.forEach(i => this.insert(i));
    }
    _insert(current, item) {
        const key = this.keyFn(item);
        if (current.key >= key && current.key <= key) {
            current.values.push(item);
            return;
        }
        else if (current.key > key) {
            const next = current.left;
            if (next === null) {
                current.left = new Node(key, [item]);
                return;
            }
            return this._insert(next, item);
        }
        else {
            const next = current.right;
            if (next === null) {
                current.right = new Node(key, [item]);
                return;
            }
            return this._insert(next, item);
        }
    }
    getInOrder(transformKey = i => i) {
        return this._getInOrder(this.root, transformKey);
    }
    _getInOrder(current, transformKey) {
        if (current === null) {
            return [];
        }
        return [
            ...this._getInOrder(current.left, transformKey),
            [transformKey(current.key), current.values],
            ...this._getInOrder(current.right, transformKey),
        ];
    }
}
exports.GroupingTree = GroupingTree;
class Node {
    key;
    values;
    left;
    right;
    constructor(key, values, left = null, right = null) {
        this.key = key;
        this.values = values;
        this.left = left;
        this.right = right;
    }
}
